import Token from '@/di/di.token'

import useDi from '../useDi'

export function useTokenManager() {
  const { container } = useDi()
  const store = container.get(Token.TOKENS_MANAGER)
  return { store }
}
